<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.1632 11.338L13.6459 8.85529V13.0021C13.6459 14.6678 12.2957 16.018 10.63 16.018C8.96442 16.018 7.61417 14.6678 7.61417 13.0021L7.61417 8.06893M7.61417 8.06893C8.65518 8.06893 9.49909 7.22502 9.49909 6.184C9.49909 5.14298 8.65518 4.29907 7.61417 4.29907C6.57316 4.29907 5.72925 5.14298 5.72925 6.184C5.72925 7.22502 6.57316 8.06893 7.61417 8.06893Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'HooksIcon'
}
</script>

